/*
gallery.js
Controls for Gallery (prev, next image)
*/


(function () {
  function Gallery(element) {
    // elements
    const ulElement = element.querySelector('ul');
    const liElements = ulElement.querySelectorAll('li');
    const imgElements = ulElement.querySelectorAll('img');
    const firstLiElement = liElements[0];
    const firstImgElement = firstLiElement.querySelector('img');
    const lastLiElement = liElements[liElements.length - 1];
    const lastImgElement = lastLiElement.querySelector('img');
    const buttonNextElement = element.querySelector('.gallery__button_next');
    const buttonPrevElement = element.querySelector('.gallery__button_prev');
    let visibleLiElement = 0;

    // functions
    function init() {
      checkForNextImage();
      checkForPrevImage();
      activateArrowKeysEvents();
      setHeightOfImages();
      setHeightOfButtons();
      setMarginForFirstImgElement();
      setPaddingForLastImgElement();
      deactivateButtons();
    }
    function setHeightOfButtons() {
      buttonNextElement.style.height = `${firstImgElement.offsetHeight}px`;
      buttonPrevElement.style.height = `${firstImgElement.offsetHeight}px`;
    }
    function deactivateButtons() {
      if (isTouchDevice()) {
        buttonNextElement.style.display = 'none';
        buttonPrevElement.style.display = 'none';
      }
    }
    // margin is important to get a correct offsetLeft in findActiveImage();
    function setMarginForFirstImgElement() {
      firstLiElement.style.marginLeft = `${window.innerWidth / 2 - firstImgElement.offsetWidth / 2}px`;
      // firstImgElement.removeEventListener('load', setMarginForFirstImgElement);
    }
    // padding is important to get white space at the end
    function setPaddingForLastImgElement() {
      if (lastImgElement.offsetWidth > 0) {
        lastLiElement.style.paddingRight = `${window.innerWidth / 2 - lastImgElement.offsetWidth / 2}px`;
        lastImgElement.removeEventListener('load', setPaddingForLastImgElement);
      } else {
        lastImgElement.addEventListener('load', setPaddingForLastImgElement);
      }
    }
    function checkForNextImage() {
      if (liElements[visibleLiElement + 1]) {
        buttonNextElement.classList.remove('is-hidden');
      } else {
        buttonNextElement.classList.add('is-hidden');
      }
    }
    function checkForPrevImage() {
      if (liElements[visibleLiElement - 1]) {
        buttonPrevElement.classList.remove('is-hidden');
      } else {
        buttonPrevElement.classList.add('is-hidden');
      }
    }
    function setHeightOfImages() {
      const heightOfFirstImg = firstImgElement.offsetHeight;
      // firstImgElement.removeEventListener('load', setHeightOfImages);
      for (let i = 1; i < imgElements.length; i++) {
        imgElements[i].style.height = `${heightOfFirstImg}px`;
      }
      setPaddingForLastImgElement();
    }
    function showNextImage() {
      const nextLiElement = liElements[visibleLiElement + 1];
      if (nextLiElement) {
        visibleLiElement++;
        const left = nextLiElement.offsetLeft + nextLiElement.offsetWidth / 2 - window.innerWidth / 2;
        SCROLLING.scrollLeft(ulElement, left);
      }
      checkForNextImage();
      checkForPrevImage();
    }
    function showPrevImage() {
      const nextLiElement = liElements[visibleLiElement - 1];
      if (nextLiElement) {
        visibleLiElement--;
        const left = nextLiElement.offsetLeft + nextLiElement.offsetWidth / 2 - window.innerWidth / 2;
        SCROLLING.scrollLeft(ulElement, left);
      }
      checkForNextImage();
      checkForPrevImage();
    }
    function findActiveImage() {
      const { scrollLeft } = ulElement;
      let j = 0;
      for (let i = 0; i < liElements.length; i++) {
        const liElement = liElements[i];
        if (scrollLeft >= liElement.offsetLeft - window.innerWidth / 2) {
          j = i;
        }
      }
      // console.log('active: ' + j);
      visibleLiElement = j;
      checkForPrevImage();
      checkForNextImage();
    }
    function activateArrowKeysEvents() {
      window.addEventListener('keydown', (e) => {
        if (e.keyCode === 39) { // right
          e.preventDefault();
          showNextImage();
        } else if (e.keyCode === 37) { // left
          e.preventDefault();
          showPrevImage();
        }
      });
    }

    function handleResize() {
      setHeightOfImages();
      setHeightOfButtons();
      setMarginForFirstImgElement();
      setPaddingForLastImgElement();
    }
    function handleButtonNextClick() {
      showNextImage();
    }
    function handleButtonPrevClick() {
      showPrevImage();
    }
    function handleScroll() {
      findActiveImage();
    }

    // event listener
    window.addEventListener('resize', handleResize);
    buttonNextElement.addEventListener('click', handleButtonNextClick);
    buttonPrevElement.addEventListener('click', handleButtonPrevClick);
    ulElement.addEventListener('scroll', handleScroll);

    // init
    if (firstImgElement.complete && typeof firstImgElement.naturalWidth !== 'undefined' && firstImgElement.naturalWidth) {
      init();
      firstImgElement.removeEventListener('load', init);
    } else {
      firstImgElement.addEventListener('load', init);
    }
  }

  // elements
  const elements = document.querySelectorAll('.gallery');

  // init
  for (let i = 0; i < elements.length; i++) {
    new Gallery(elements[i]);
  }
}());
